import Glide from '@glidejs/glide'

export default class NewsTeaser {
    static init() {
        Array.prototype.forEach.call(document.querySelectorAll('.news-teaser'), el => {
            new NewsTeaser(el)
        });
    }

    constructor(el) {
        if (!el) return;
        this.el = el;
        this.imageSliderElement = this.el.querySelector('.news-teaser__image-slider');
        this.contentSliderElement = this.el.querySelector('.news-teaser__content-slider');
        this.bulletElements = this.el.querySelectorAll('.news-teaser__bullet');
        this.contentSliderArrows = this.contentSliderElement.querySelectorAll('.news-teaser__glide__arrow');
        this.contentSliderArrowsArray = Array.from(this.contentSliderArrows);
        this.bulletElementsArray = Array.from(this.bulletElements);
        this.currentBulletElement = this.el.querySelector('.news-teaser__bullet--active');
        this.isMobile = window.innerWidth < 1024;
        this.imageSliderOptions = {
            gap: 0,
            rewind: false
        };
        this.contentSliderOptions = {
            gap: 0,
            rewind: false,
            throttle: this.isMobile ? 25 : 1,
            animationDuration: this.isMobile ? 300 : 0,
            swipeThreshold:  this.isMobile ? 80 : false,
            dragThreshold:  this.isMobile ? 120: false
        };

        this.imageSlider = new Glide(this.imageSliderElement, this.imageSliderOptions);
        this.contentSlider = new Glide(this.contentSliderElement, this.contentSliderOptions)


        this.imageSlider.mount()
        this.contentSlider.mount()

        this.contentSlider.on('run', () => {
            // synchronize sliders
            this.imageSlider.go('=' + this.contentSlider.index);
        });

        this.imageSlider.on('run', () => {
            // synchronize sliders
            this.contentSlider.go('=' + this.imageSlider.index);

            // mark bullet as active
            let el = this.bulletElementsArray[this.imageSlider.index];
            this.currentBulletElement.classList.remove('news-teaser__bullet--active');
            el.classList.add('news-teaser__bullet--active');
            this.currentBulletElement = el;
        });

        // move slides on bullet click
        this.bulletElementsArray.forEach(el => {
            el.addEventListener('click', () => {
                if (this.currentBulletElement.isSameNode(el)) return
                this.imageSlider.go(el.dataset.glideDir);
            });
        });
    }
}
